import { Injectable, inject } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Auth } from "@angular/fire/auth";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private auth: Auth = inject(Auth);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    if (typeof this.auth.authStateReady === "function") {
      await this.auth.authStateReady();
    }

    if (this.auth.currentUser) return true;

    await this.router.navigate(["/home"]);
    return false;
  }
}
